import { render, staticRenderFns } from "./StudentAccounts.vue?vue&type=template&id=2b2c4d0c&scoped=true"
import script from "./StudentAccounts.vue?vue&type=script&lang=js"
export * from "./StudentAccounts.vue?vue&type=script&lang=js"
import style0 from "./StudentAccounts.vue?vue&type=style&index=0&id=2b2c4d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2c4d0c",
  null
  
)

export default component.exports